const newUnit = {
  snackbar: "Your update is ready",
  name: "Unit Name",
  save: "Save",
  cancel: "Cancel",
  area: "Area",
  formTitle: "New Unit",
  confirm: "Are you sure you want to delete this item?",
  close: "Close",
  delete: "Delete"
};
export default newUnit;
